import React from 'preact';
import { useState } from "preact/hooks";
import { useEffect } from "preact/compat";
import constants from "../../constants";

interface PriceNameFloatRightWithDotLeadersProps {
  active: boolean;
}

export default function PriceNameFloatRightWithDotLeaders({ active }: PriceNameFloatRightWithDotLeadersProps) {
  const [primaryColor, setPrimaryColor] = useState('');
  const [secondaryColor, setSecondaryColor] = useState('');

  useEffect(() => {
    if (active) {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_ACTIVE);
      setSecondaryColor(constants.PRICE_COLOR_SECONDARY_ACTIVE);
    } else {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_INACTIVE);
      setSecondaryColor(constants.PRICE_COLOR_SECONDARY_INACTIVE);
    }
  }, [active]);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.615 24.215">
      <g id="c" transform="translate(0 -0.91)">
        <g id="Group_2" data-name="Group 2" transform="translate(0 0.91)">
          <g id="d" transform="translate(0 12.107)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="117.615" height="4.324" fill="#cfcfcf" />
          </g>
          <g id="e" transform="translate(0 19.891)">
            <rect id="Rectangle_4" data-name="Rectangle 4" width="106.373" height="4.324" fill="#cfcfcf" />
          </g>
          <g id="f">
            <rect id="Rectangle_5" data-name="Rectangle 5" width="70.05" height="6.919" fill="#777" />
          </g>
          <g id="Group_1" data-name="Group 1" transform="translate(113.291 0.078)" style="isolation: isolate">
            <path id="Path_1" data-name="Path 1" d="M86.847,6.054v.709H86.1v-.7a2.794,2.794,0,0,1-1.833-.813l.6-.839a2.255,2.255,0,0,0,1.237.657V3.848c-.8-.19-1.678-.5-1.678-1.557A1.658,1.658,0,0,1,86.1.726V0h.744V.744a2.711,2.711,0,0,1,1.583.692l-.614.813a2.011,2.011,0,0,0-.969-.5v1.09c.813.208,1.7.519,1.7,1.583,0,.856-.562,1.522-1.7,1.643Zm-.666-3.39V1.678c-.4.035-.605.242-.605.519C85.576,2.439,85.827,2.569,86.181,2.664Zm1.245,1.868c0-.285-.268-.424-.649-.528v1.09C87.219,5.033,87.427,4.791,87.427,4.532Z" transform="translate(-84.27)" fill="#777" />
          </g>
          <g id="Repeat_Grid_1" data-name="Repeat Grid 1" transform="translate(71 4.09)" clip-path="url(#clip-path)">
            <g transform="translate(-199 -90)">
              <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(199 90)" fill="#777" stroke="#777" stroke-width="1">
                <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
                <circle cx="1.5" cy="1.5" r="1" fill="none" />
              </g>
            </g>
            <g transform="translate(-194 -90)">
              <g id="Ellipse_1-2" data-name="Ellipse 1" transform="translate(199 90)" fill="#777" stroke="#777" stroke-width="1">
                <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
                <circle cx="1.5" cy="1.5" r="1" fill="none" />
              </g>
            </g>
            <g transform="translate(-189 -90)">
              <g id="Ellipse_1-3" data-name="Ellipse 1" transform="translate(199 90)" fill="#777" stroke="#777" stroke-width="1">
                <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
                <circle cx="1.5" cy="1.5" r="1" fill="none" />
              </g>
            </g>
            <g transform="translate(-184 -90)">
              <g id="Ellipse_1-4" data-name="Ellipse 1" transform="translate(199 90)" fill="#777" stroke="#777" stroke-width="1">
                <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
                <circle cx="1.5" cy="1.5" r="1" fill="none" />
              </g>
            </g>
            <g transform="translate(-179 -90)">
              <g id="Ellipse_1-5" data-name="Ellipse 1" transform="translate(199 90)" fill="#777" stroke="#777" stroke-width="1">
                <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
                <circle cx="1.5" cy="1.5" r="1" fill="none" />
              </g>
            </g>
            <g transform="translate(-174 -90)">
              <g id="Ellipse_1-6" data-name="Ellipse 1" transform="translate(199 90)" fill="#777" stroke="#777" stroke-width="1">
                <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
                <circle cx="1.5" cy="1.5" r="1" fill="none" />
              </g>
            </g>
            <g transform="translate(-169 -90)">
              <g id="Ellipse_1-7" data-name="Ellipse 1" transform="translate(199 90)" fill="#777" stroke="#777" stroke-width="1">
                <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
                <circle cx="1.5" cy="1.5" r="1" fill="none" />
              </g>
            </g>
            <g transform="translate(-164 -90)">
              <g id="Ellipse_1-8" data-name="Ellipse 1" transform="translate(199 90)" fill="#777" stroke="#777" stroke-width="1">
                <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
                <circle cx="1.5" cy="1.5" r="1" fill="none" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
